var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.row.DireccionColor)?_c('div',{style:({
    'border-color': `${_vm.row.DireccionColor} !important`,
    color: `${_vm.row.DireccionColor}`,
    border: 'solid',
    'border-width': '1px',
    'border-radius': '5px',
    'text-align': 'center'
  })},[_vm._v(" "+_vm._s(_vm.row.TipoSolicitud)+" ")]):_c('div',[_vm._v(" "+_vm._s(_vm.row.TipoSolicitud)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }